snt-nav-item {
    position: relative;
    .dropdown-toggle {
        &:after {
            display: none;
        }
        margin-right: 40px;
    }
    .actions-nav>*:not(:first-child) .dropdown-menu {
        background-color: white;
        border-bottom-left-radius: 30px;
        border-bottom-right-radius: 30px;
        box-shadow: 0px 1px 4px #b2b2b2;
        top: calc(100% + 1rem);
        left: -1.875rem;
        font-family: 'Averta-Regular', sans-serif;
        border: none;
        padding: 0.225rem 0 0 0.875rem;
        @media(min-width: map-get($grid-breakpoints, lg)) {
            padding: 1.5rem 1.875rem;
        }
        a {
            margin-left: 15px;
            @media (min-width: map-get($grid-breakpoints, md)) {
                margin-left: initial;
            }
        }
        snt-nav-item {
            line-height: 1.3125rem;
        }
    }
    .expander {
        outline: none;
        snt-icon {
            outline: none;
        }
    }
    snt-action-button button.get-a-quote-header {
        width: 150px;
        height: 45px;
        border-radius: 45px;
        text-align: center;
        vertical-align: middle;
        padding: 0;
    }
    snt-link a {
        color: #323232;
        margin: 2px;
        outline: 2px solid transparent;
        padding: 0;
        white-space: nowrap;
        display: inline-block;
        margin: 0;
        position: relative;
        text-decoration: none;
        border-bottom: none;
        font-family: Averta-ExtraBold;
        font-size: 1em;
        background-image: none;
    }
    &.noclick-nav {
        snt-link a:active {
            pointer-events: none;
        }
    }
}

.no-link-a-subnav {
    margin: 2px;
    outline: 2px solid transparent;
    padding: 0;
    white-space: nowrap;
    background-image: none;
    color: #ffffff;
    display: inline-block;
    position: relative;
    text-decoration: none;
    border-bottom: none;
    &:active,
    &:focus,
    &:hover {
        color: $color-primary;
        font-family: Averta-ExtraBold;
        text-decoration: none;
        &:before {
            visibility: hidden;
        }
    }
    &:focus {
        outline: 2px solid $color-grey-07;
        padding: 0;
    }
    &:before {
        background-color: $color-primary;
        height: 2px;
    }
    /* Take up bold face space up front to prevent anchor element expanding on hover and affecting sibling elements */
    &:after {
        display: block;
        font-family: Averta-ExtraBold;
        content: attr(hidden-title);
        height: 0;
        overflow: hidden;
        visibility: hidden;
        font-size: 1.015em;
    }
}

.no-link-a-footer {
    font-size: 0.875em;
    color: #323232;
    padding: 0;
    text-decoration: none;
    background-image: linear-gradient(transparent, transparent), linear-gradient(#147582, #147582);
    background-size: 100% 1px, 0 1px;
    background-position: 100% 100%, 1px 100%;
    background-repeat: no-repeat;
    line-height: 1.2;
    position: relative;
    background-color: transparent;
    white-space: pre-wrap;
    &:hover {
        text-decoration: none;
        background-image: linear-gradient(transparent, transparent), linear-gradient(#147582, #147582);
        background-size: 0 1px, 100% 1px;
        -webkit-transition: all 0.25s ease-in-out 0s;
        transition: all 0.25s ease-in-out 0s;
        transition-property: background-size;
        color: #147582;
    }
    &:focus {
        padding: 1px;
        box-sizing: border-box;
        margin: -1px;
        background-image: linear-gradient(transparent, transparent), linear-gradient(#147582, #147582);
        background-size: 0 1px, 100% 1px;
        -webkit-transition: all 0.25s ease-in-out 0s;
        transition: all 0.25s ease-in-out 0s;
        transition-property: background-size;
    }
    &:active {
        outline: none;
    }
}